import { getSendErrorKey } from 'api/mutations/chat/chat'
import { ChatSendErrorCode } from 'api/mutations/chat/types'
import { Maybe } from 'types/Maybe'

interface ChatSendErrorEffect {
  redirectToChatList: boolean
  messageKey: Maybe<string>
}

const getChatSendErrorEffect = (code: ChatSendErrorCode): ChatSendErrorEffect => ({
  redirectToChatList: code === 'NOT_FOUND' || code === 'COMPANY_UNAVAILABLE',
  messageKey: getSendErrorKey(code),
})

export type { ChatSendErrorEffect }
export { getChatSendErrorEffect }
